import type { QueryClient } from "@tanstack/vue-query";
import { reservationRequestKeys, reservationKeys } from "./queryKeys";

export async function invalidateReservationRequests(
  queryClient: QueryClient,
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ["reservationRequests"] }),
    queryClient.invalidateQueries({ queryKey: ["reservationCounts"] }),
  ]);
}

export async function invalidateReservations(
  queryClient: QueryClient,
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ["reservations"] }),
    queryClient.invalidateQueries({ queryKey: ["reservationCounts"] }),
    queryClient.invalidateQueries({ queryKey: ["tables"] }),
  ]);
}

export async function invalidateAllReservationQueries(
  queryClient: QueryClient,
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ["tables"] }),
    queryClient.invalidateQueries({ queryKey: ["reservationCounts"] }),
    queryClient.invalidateQueries({ queryKey: ["reservations"] }),
    queryClient.invalidateQueries({ queryKey: ["reservationRequests"] }),
  ]);
}

// pendingReservationRequestsCount lives in ShopConnection, not Vue Query.
// Count updates are triggered by shop.refreshData() after mutations.

export async function invalidateAfterAcceptRequest(
  queryClient: QueryClient,
  params: { requestId: string; reservationId?: string },
): Promise<void> {
  await Promise.all([
    invalidateReservationRequests(queryClient),
    invalidateReservations(queryClient),
  ]);
}

export async function invalidateAfterRejectRequest(
  queryClient: QueryClient,
  params: { requestId: string },
): Promise<void> {
  await invalidateReservationRequests(queryClient);
}
